export enum groupConstants {
  GET_GROUPS = 'GET_GROUPS',
  GET_GROUP = 'GET_GROUP',
  ADD_GROUP = 'ADD_GROUP',
  DELETE_GROUPS = 'DELETE_GROUPS',
  EDIT_GROUP = 'EDIT_GROUP',
  DELETE_MULTIPLE_GROUPS = 'DELETE_MULTIPLE_GROUPS',
}
